export enum DateFrequencyEnum {
	EveryHour = 'Every hour',
	EveryShift = 'Every shift',
	EveryDay = 'Every day',
	EveryWeek = 'Every week',
	EveryMonth = 'Every month',
	EveryQuarter = 'Every quarter',
}
